import React, { useState } from "react";
import { CalendarDays, X } from "lucide-react";
import { nb } from "date-fns/locale";
import { cn } from "@/lib/utils";
import { fmtDate } from "@/lib/format";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { fieldCls } from "@/components/veiviser/WizardChrome";

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const parse = (s) => { const [y, m, d] = String(s || "").split("-").map(Number); return y && m && d ? new Date(y, m - 1, d) : undefined; };

/** A Norwegian date field: «1. mars 2027» on the button, a Monday-first calendar under it, one click to clear. */
export function DateField({ value, onChange, placeholder = "Velg dato", testId, future = false }) {
  const [open, setOpen] = useState(false);
  const sel = parse(value);
  const today = new Date(new Date().setHours(0, 0, 0, 0));
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <div className="relative">
        <PopoverTrigger asChild>
          <button type="button" className={cn(fieldCls, "flex items-center gap-2.5 text-left", !sel && "text-muted-foreground/60")} data-testid={testId} data-value={value || ""}>
            <CalendarDays className="h-4 w-4 shrink-0 text-muted-foreground" />
            <span className="truncate">{sel ? fmtDate(value, { year: true }) : placeholder}</span>
          </button>
        </PopoverTrigger>
        {sel ? <button type="button" onClick={() => onChange("")} className="absolute right-2.5 top-1/2 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full text-muted-foreground hover:bg-black/[0.05] hover:text-foreground" aria-label="Fjern dato" data-testid={`${testId}-clear`}><X className="h-3.5 w-3.5" /></button> : null}
      </div>
      <PopoverContent align="start" className="w-auto rounded-[16px] p-0" data-testid={`${testId}-calendar`}>
        <Calendar mode="single" locale={nb} weekStartsOn={1} selected={sel} defaultMonth={sel} disabled={future ? { before: today } : undefined} onSelect={(d) => { if (d) { onChange(iso(d)); setOpen(false); } }} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
